// Loads posthog-js as its own chunk. Kept in a .js file with a .d.ts beside it so the app's older
// TypeScript checker never parses posthog-js's own (newer) type definitions.
export const loadPosthog = () => import(/* webpackChunkName: "posthog" */ "posthog-js");
